import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';

export default function Navbar({ t, lang, toggleLang }) {
  const [scrolled, setScrolled]       = useState(false);
  const [menuOpen, setMenuOpen]       = useState(false);
  const [dropOpen, setDropOpen]       = useState(false);
  const dropRef    = useRef(null);
  const closeTimer = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setDropOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const mainLinks = [
    { href: '#home',    label: t.home },
    { href: '#about',   label: t.about },
    { href: '#gallery', label: t.gallery },
    { href: '#contact', label: t.contact },
  ];

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <a href="#home" className="navbar-brand">Master Dante</a>

      <div className={`navbar-links${menuOpen ? ' open' : ''}`}>

        {mainLinks.map(l => (
          <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)}>
            {l.label}
          </a>
        ))}

        {/* Lessons dropdown */}
        <div
          className={`circles-dropdown${dropOpen ? ' open' : ''}`}
          ref={dropRef}
          onMouseEnter={() => { clearTimeout(closeTimer.current); setDropOpen(true); }}
          onMouseLeave={() => { closeTimer.current = setTimeout(() => setDropOpen(false), 220); }}
        >
          <a href="#services" className="circles-trigger" onClick={() => setMenuOpen(false)}>
            {t.lessons}
            {' '}<span className="drop-arrow">▾</span>
          </a>

          <div className="circles-menu">
            {(t.lessonItems || []).map((item, i) => (
              <a
                key={i}
                href={item.href}
                className="circles-menu-item"
                onClick={() => { setMenuOpen(false); setDropOpen(false); }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>

        <button className="lang-toggle" onClick={toggleLang} aria-label="Toggle language">
          {lang === 'en' ? 'CS' : 'EN'}
        </button>

        <a href="https://hedone.cz" target="_blank" rel="noopener noreferrer" className="hedone-link">
          Hedone ↗
        </a>
      </div>

      <button
        className={`burger${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
